import React, { Component } from "react";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './css/custom.css';
import './css/ExpandTable.css';
import { Col, Row, CardBody, Card, CardHeader, Label, Spinner} from 'reactstrap';
import { Nav, NavItem, NavLink, TabContent, TabPane, Alert } from 'reactstrap';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { AppContext } from './../AppContext';
import classnames from 'classnames';
import ListaCargaReporteSubdecanos from './ListaCargaReporteSubdecanos';
import ListaCargaReporteDecanos from './ListaCargaReporteDecanos';
import ListaCargaReporteVicerrector from './ListaCargaReporteVicerrector';
import ListaCargaReporteViceEnv from './ListaCargaReporteViceEnv';
import url from './variables/url.js';
const local = url.localBack;


class Reportes extends Component {
    constructor(props) {
        super(props);
        let currentUser = this.context;
        this.state = {
            profesores: [],
            profesoresDec: [],
            profesoresVice1: [],
            profesoresVice2: [],
            activeTab: 1,
            iduser: 0,
            roles: [],
            loading: true,
            loadingDecR: true,
            loadingVice1: true,
            loadingVice2: true,
            loadingSub: true,
            loadingDec: true,
            subdecanos: [],
            decanos: [],
            subdecano: 0,
            decano: 0
        };
        this.populateSub();
        this.populateDec();
    }

    componentDidMount() {
        let id = 0;
        let currentUser = this.context;
        //console.log('Mount', currentUser);
        if (currentUser != null) {
            this.populateSub();
            this.populateDec();
            //console.log(currentUser)
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('SUBDECANO')) {
                this.populate(currentUser.idpersona);
            } else if (currentUser.roles.includes('DECANO')) {
                this.populateDecano(currentUser.idpersona);
                this.setState({ activeTab: 2 });
            } else if (currentUser.roles.includes('VICERRECTOR')) {                
                this.populateVice1();
                this.populateVice2();
                this.setState({ activeTab: 3 });
            } else if (currentUser.roles.includes('ADMINISTRADOR')) {
                this.populate(0);
                this.populateDecano(0);
                this.populateVice1();
                this.populateVice2();
            }
        }
        //console.log("id", id);
    }

    componentDidUpdate() {
        let currentUser = this.context;
        //console.log('Update', currentUser);        
        if (currentUser != null && this.state.iduser == 0) {
            this.populateSub();
            this.populateDec();
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('SUBDECANO')) {                
                this.populate(currentUser.idpersona);
            }
            if (currentUser.roles.includes('DECANO')) {
                this.populateDecano(currentUser.idpersona);
                this.setState({ activeTab: 2 });
            }
            if (currentUser.roles.includes('VICERRECTOR')) {
                this.populateVice1();
                this.populateVice2();
                this.setState({ activeTab: 3 });
            }
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                this.populate(0);
                this.populateDecano(0);
                this.populateVice1();
                this.populateVice2();
            }
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
    }


    populate(id) {
        fetch(local + 'Validacion/GetReporteSubdecanos/'+id, {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                //console.log("Subdecano", data)
                this.setState({ profesores: data, loading: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    populateDecano(id) {
        fetch(local + 'Validacion/GetReporteDecanos/' + id, {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                //console.log("Decano", data)
                this.setState({ profesoresDec: data, loadingDec: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    populateVice1() {
        fetch(local + 'Validacion/GetReporteVicerrector/', {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                //console.log("DATAFORRRRRM", data)
                this.setState({ profesoresVice1: data, loadingVice1: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    populateVice2() {
        fetch(local + 'Validacion/GetReporteRecibidosVice/', {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                //console.log("DATAFORRRRRM", data)
                this.setState({ profesoresVice2: data, loadingVice2: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    populateSub() {
        fetch(local + 'Administrador/GetSubdecanos', {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                /*console.log("DATAFORRRRRM", data)*/
                this.setState({ subdecanos: data, loadingSub: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    populateDec() {
        fetch(local + 'Administrador/GetDecanos', {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                /*console.log("DATAFORRRRRM", data)*/
                this.setState({ decanos: data, loadingDecR: false })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    handleChangeUnidad = selectedOption => {
        const { value, label } = selectedOption;
        this.setState({ loading: true });
        let mapeo = []
        if (value === 0) {            
            mapeo = { label: "Todos", value: 0 };
            this.setState({ subdecano: mapeo });
            this.populate(0);
        } else {
            mapeo = { label: label, value: value };
            this.setState({ subdecano: mapeo });
            this.populate(value);
        }
    };

    handleChangeDecano = selectedOption => {
        const { value, label } = selectedOption;
        this.setState({ loadingDec: true });
        let mapeo = []
        if (value === 0) {
            mapeo = { label: "Todos", value: 0 };
            this.setState({ decano: mapeo });
            this.populateDecano(0);
        } else {
            mapeo = { label: label, value: value };
            this.setState({ decano: mapeo });
            this.populateDecano(value);
        }
        //console("D", this.state.decano);
    };

    render() {
        let { subdecanos, decanos, roles } = this.state;
        let currentUser = this.context;
        let unidadText = subdecanos === null || subdecanos.length === 0 ? [] : subdecanos.map(x => ({ label: x.nombreFinal, value: x.idSubdecano }));
        unidadText.push({ label: "Todos", value: 0 });
        let decanoText = decanos === null || decanos.length === 0 ? [] : decanos.map(x => ({ label: x.nombreFinal, value: x.idDecano }));
        decanoText.push({ label: "Todos", value: 0 });
        return (            
            <Row className="d-flex flex-row py-2">
                <h3><label style={{ color: '#243165', fontWeight: 'bold' }} > Reportes </label></h3>
                {currentUser !== null ? <>
                    <Nav tabs>
                        {currentUser.roles.includes('SUBDECANO') || currentUser.roles.includes('ADMINISTRADOR')
                            ? <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === 1 })}
                                    onClick={() => { this.toggle(1) }}
                                >
                                    Subdecanos
                                </NavLink>
                            </NavItem>
                            : <></>}
                        {currentUser.roles.includes('DECANO') || currentUser.roles.includes('ADMINISTRADOR')
                         ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 2 })}
                                onClick={() => { this.toggle(2) }}
                            >
                                Decanos
                            </NavLink>                            
                            </NavItem>
                         : <></>}
                        {currentUser.roles.includes('VICERRECTOR') || currentUser.roles.includes('ADMINISTRADOR')
                        ? <NavItem>
                            <NavLink
                                className={classnames({ active: this.state.activeTab === 3 })}
                                onClick={() => { this.toggle(3) }}
                            >
                                Vicerrector
                            </NavLink>
                           </NavItem>
                            : <></>}
                        {currentUser.roles.includes('VICERRECTOR') || currentUser.roles.includes('ADMINISTRADOR')
                         ? <NavItem>
                              <NavLink
                                className={classnames({ active: this.state.activeTab === 4 })}
                                onClick={() => { this.toggle(4) }}
                               >
                                Recibidos
                               </NavLink>
                           </NavItem>
                         : <></>}
                    </Nav>
                    <br />
                        <TabContent activeTab={this.state.activeTab}>
                            {/*Pesta�a Todos*/}
                        <TabPane tabId={1}>                            
                            <Row>
                                <Col xs="12">
                                    {!this.state.loadingSub && currentUser.roles.includes('ADMINISTRADOR') ? <>
                                        <label>
                                            Subdecano
                                        </label>
                                        <Select name="Subdecano"
                                            options={unidadText}
                                            value={this.state.unidad}
                                            onChange={this.handleChangeUnidad} />
                                    </> : <></>}
                                </Col>
                                {/*<Col xs="4">*/}
                                    
                                {/*</Col>*/}
                                {/*<Col xs="4">*/}
                                    
                                {/*</Col>*/}
                            </Row>
                            <Row></Row>
                            {this.state.loading ? <Spinner animation="grow" /> : <ListaCargaReporteSubdecanos carga={this.state.profesores} rol={currentUser.roles} location={this.props.location} />}
                        </TabPane>
                        <TabPane tabId={2}>
                            <Row>
                                <Col xs="12">
                                    {!this.state.loadingDecR && currentUser.roles.includes('ADMINISTRADOR') ? <>
                                        <label>
                                            Decano
                                        </label>
                                        <Select name="Decano"
                                            options={decanoText}
                                            value={this.state.decano}
                                            onChange={this.handleChangeDecano} />
                                    </> : <></>}
                                </Col>
                                {/*<Col xs="4">*/}

                                {/*</Col>*/}
                                {/*<Col xs="4">*/}

                                {/*</Col>*/}
                            </Row>
                            <Row></Row>
                            {this.state.loadingDec ? <Spinner animation="grow" /> : <ListaCargaReporteDecanos carga={this.state.profesoresDec} location={this.props.location} />}
                        </TabPane>
                        <TabPane tabId={3}>
                            <Row>
                                {this.state.loadingVice1 ? <Spinner animation="grow" /> : <ListaCargaReporteVicerrector carga={this.state.profesoresVice1} location={this.props.location} />}
                            </Row>
                        </TabPane>
                        <TabPane tabId={4}>
                            <Row>
                                {this.state.loadingVice2 ? <Spinner animation="grow" /> : <ListaCargaReporteViceEnv carga={this.state.profesoresVice2} location={this.props.location} />}
                            </Row>
                        </TabPane>
                        </TabContent>
                </> : <></>}
            </Row>
        );
    }
}
Reportes.contextType = AppContext;
export default withRouter(Reportes);